import HTTP from "../../http";

const PAYMENT_ENDPOINT = "/payments";
const STRIPE_ACCOUNT_ENDPOINT = "/user/stripeAccount";

export async function getStripeAccount() {
  return await HTTP.get(PAYMENT_ENDPOINT + STRIPE_ACCOUNT_ENDPOINT, {
    headers: { "Content-Type": "application/json" }
  });
}
